module.exports = __webpack_public_path__ + "static/media/altair.d8834136.png";